// extracted by mini-css-extract-plugin
module.exports = {"root":"ConfirmCredsChange_root__2VXW_","info":"ConfirmCredsChange_info__OPaUW","cardBody":"ConfirmCredsChange_cardBody__3wGTC"};